import React from "react";

const features = [
  {
    icon: "/hero1.webp", // Replace with actual paths in public/icons/
    title: "Tailored Software Solutions",
    description: "We design and build intuitive, scalable software—web, mobile, cloud, AI-powered—that’s precisely aligned with your business needs.",
    bg: "bg-[#fff8eb]",
  },
  {
    icon: "/hero2.webp",
    title: "Product Thinking & Strategy",
    description: "Beyond coding, we research, plan, and define the right tech solutions. Our process ensures your product is user-focused, viable, and built to grow.",
    bg: "bg-[#def5f8]",
  },
  {
    icon: "/hero3.webp",
    title: "Sector Expertise",
    description: "Whether it’s B2B SaaS, CRMs, ERPs, logistics apps, or real-time systems—we bring both depth and breadth to deliver high-impact results.",
    bg: "bg-[#f1ebff]",
  },
  {
    icon: "/hero4.webp",
    title: "Clean code & optimised",
    description: "With Senyumi, you’ll never have to worry about your website looking great on any.",
    bg: "bg-[#e0f8de]",
  },
];

const Hero = () => {
  return (
    <section className="bg-gradient-to-b from-[#FAFBFF] to-white py-20 px-4">
      {/* Badge */}
      <div className="text-center mb-4 mt-8">
        <span className="text-sm text-primary uppercase text-green-700 font-semibold px-4 py-1 rounded-full">
          Welcome to Minterminds
        </span>
      </div>

      {/* Main Heading */}
      <h1 className="text-4xl md:text-5xl font-extrabold !leading-snug text-center text-[#0A033C] mb-4">
        Empowering Digital Transformation<br/> with Smart Software

      </h1>

      {/* Subheading */}
      <p className="text-center text-[#6B7280] max-w-4xl mx-auto text-md mb-24">
At Minterminds, we turn bold ideas into powerful digital products. From sleek mobile apps to enterprise-grade platforms, we're your strategic partner in navigating the digital future.      </p>

      {/* Feature Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
        {features.map((item, index) => (
          <div
            key={index}
            className={`${item.bg} p-6 rounded-xl shadow-sm hover:shadow-md transition`}
          >
            <img src={item.icon} alt={item.title} className="h-18 mb-4" />
            <h3 className="text-sm font-bold text-gray-900 mb-2">{item.title}</h3>
            <p className="text-md !leading-normal font-semibold text-[#6B7280]">{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Hero;
